import DapDSContentSwitcherItem from './content-switcher-item.component'

export * from './content-switcher-item.component'
export default DapDSContentSwitcherItem

DapDSContentSwitcherItem.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-content-switcher-item': DapDSContentSwitcherItem
  }
}
